import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/tema3/GLB_T3_Panecitos.glb"
import { GUI } from "dat.gui";
import gsap from "gsap";

export class PanecitosTwo extends Mesh {
	constructor(loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(2, 2, 2);
		// this.rotation.y = MathUtils.degToRad(90)
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			this.add(gltf.scene);

			this.Dona = gltf.scene.getObjectByName("Dona", true);
			this.Cuernito = gltf.scene.getObjectByName("Cuernito", true);
			this.Panque = gltf.scene.getObjectByName("Panque", true);
		});
	}

	onAnimationMovePosition(object, target = { x: 0, y: 0, z: 0 }, duration = 2, callBack = () => { }) {
		if (!object) {
			return
		}

		gsap.to(object.position,
			{
				duration,
				x: target.x,
				y: target.y,
				z: target.z,
				onComplete: () => {
					callBack();
				},
			})
	}

	onAnimationMoveRotation(object, target = { x: 0, y: 0, z: 0 }, duration = 2, callBack = () => { }) {
		if (!object) {
			return
		}

		gsap.to(object.rotation,
			{
				duration,
				x: target.x,
				y: target.y,
				z: target.z,
				onComplete: () => {
					callBack();
				},
			})
	}

	helpers(limitPosicion = 20, limitRotation = 5) {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("Panes");
		premiaFolder.add(this.position, "x", -limitPosicion, limitPosicion).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -limitPosicion, limitPosicion).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -limitPosicion, limitPosicion).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -limitRotation, limitRotation).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -limitRotation, limitRotation).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -limitRotation, limitRotation).step(0.0001).name("rotation Z");
		premiaFolder.add(this, "visible").name("Visible");
	}

	helpersChild() {
		// this.helperMethod("Dona", this.Dona);
		this.helperMethod("Cuernito", this.Cuernito);
		// this.helperMethod("Panque", this.Panque);
	}

	helperMethod(name, object, limitPosicion = 20, limitRotation = 5) {
		const { position, rotation } = object;
		const gui = new GUI();
		const folferMostrador = gui.addFolder(name);
		folferMostrador.add(position, "x", -limitPosicion, limitPosicion).step(0.0001).name("Posición X");
		folferMostrador.add(position, "y", -limitPosicion, limitPosicion).step(0.0001).name("Posición Y");
		folferMostrador.add(position, "z", -limitPosicion, limitPosicion).step(0.0001).name("Posición Z");
		folferMostrador.add(rotation, "x", -limitRotation, limitRotation).step(0.0001).name("rotation X");
		folferMostrador.add(rotation, "y", -limitRotation, limitRotation).step(0.0001).name("rotation Y");
		folferMostrador.add(rotation, "z", -limitRotation, limitRotation).step(0.0001).name("rotation Z");
		folferMostrador.add(object, "visible").name("Visible");
	}


	renderAnimations() { }
}
